
import { defineComponent } from "vue";

export default defineComponent({
  name: "ErrorModal",
  methods: {
    closeModal() {
      this.$emit("closeErrorModal");
    },
  },
});
